import { MiddlewareDtoImpl } from '../../../dto/middlewaredto';
import { MiddlewareAPIResponse } from '../../middlewareapiresponse';

export interface CreateGroupResponse extends MiddlewareAPIResponse
{
}

export class CreateGroupResponseDtoImpl extends MiddlewareDtoImpl implements CreateGroupResponse
{
   
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/core/api/group/creategroup/creategroupresponse.tsx